// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../Config.bs.js";
import * as BulkUploadRepo from "./BulkUploadRepo.bs.js";
import * as DummyBulkUploadRepo from "./DummyBulkUploadRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return {
            bulkUpload: DummyBulkUploadRepo.BulkUploadRepo.bulkUpload,
            fetchBulkReasons: DummyBulkUploadRepo.BulkUploadRepo.fetchBulkReasons
          };
  } else {
    return BulkUploadRepo.BulkUploadRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
